import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import { withTranslation } from 'gatsby-plugin-react-i18next'
import { Helmet } from 'react-helmet'

import SEO from 'src/components/seo'
import Analytics from 'src/utils/Analytics'
import CalPlusHero from '../../components/CalPlus/CalPlusHero'
import CalPlusFeatures from '../../components/CalPlus/CalPlusFeatures'

class UpsellProductPage extends React.Component {
  componentDidMount() {
    const {
      data: { digitalProduct },
      pageContext,
    } = this.props
    const retailPage = pageContext?.layout === 'retail'
    Analytics.track(
      `Viewed ${retailPage ? 'Retail ' : ''}${
        Analytics.trackingConstants[digitalProduct.handle] || digitalProduct.handle
      } Product Page`
    )
  }

  render() {
    const {
      data,
      t,
      pageContext,
      data: { calPlusImage },
    } = this.props
    const retailPage = pageContext?.layout === 'retail'
    const product = data.digitalProduct
    const upsellConstants = {
      seoTitle: {
        'calendar-skylight-plus': 'Skylight Calendar Plus | Digital Calendar Upgraded Subscription',
      },
      seoDescription: {
        'calendar-skylight-plus':
          'Calendar Plus is the easiest way to plan everything. Instantly plan meals for the week, automatically import events from emails, and turn your Calendar into a photo frame.',
      },
      seoImagePathOverride: {
        'calendar-skylight-plus': calPlusImage.childImageSharp.gatsbyImageData.images.fallback.src,
      },
    }

    const finalImagePath =
      upsellConstants.seoImagePathOverride[product.handle] ||
      product.images[0].gatsbyImageData.images.fallback.src

    return (
      <>
        {retailPage && (
          <Helmet>
            <meta name="robots" content="noindex" />
          </Helmet>
        )}
        <SEO
          title={t(upsellConstants.seoTitle[product.handle]) || product.title}
          description={t(upsellConstants.seoDescription[product.handle])}
          path={`/products/${product.handle}/`}
          canonicalPath="/products/calendar-skylight-plus/"
          imagePath={finalImagePath}
        />
        <CalPlusHero product={product} retailPage={retailPage} />
        <CalPlusFeatures product={product} retailPage={retailPage} />
      </>
    )
  }
}

UpsellProductPage.propTypes = {
  data: PropTypes.object.isRequired,
  t: PropTypes.func,
  pageContext: PropTypes.object,
}

export const query = graphql`
  query ($handle: String!, $language: String!) {
    digitalProduct: shopifyProduct(handle: { eq: $handle }) {
      id
      title
      handle
      productType
      description
      descriptionHtml
      shopifyId
      variants {
        id
        title
        price
        shopifyId
      }
      images {
        id
        gatsbyImageData
      }
    }
    locales: allLocale(filter: { ns: { in: ["common", "upsell"] }, language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    calPlusImage: file(relativePath: { eq: "meta-seo/calendar-plus.jpg" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
      }
    }
  }
`

export default withTranslation()(UpsellProductPage)
